import { render, staticRenderFns } from "./CheckoffTypeRoles.vue?vue&type=template&id=1dab646f"
import script from "./CheckoffTypeRoles.vue?vue&type=script&lang=js"
export * from "./CheckoffTypeRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports